// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { userInformationStyles } from "@awc/Overrides/Widgets/AccountSettings/AccountSettingsUserInformation";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

userInformationStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

userInformationStyles.inputsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

userInformationStyles.userInformationTitle = {
    as: "h2",
    variant: "h4",
};

userInformationStyles.changePasswordLink = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        lineHeight: fontConfig.lineHeight.small,
    },
    css: css`
        white-space: nowrap;
        flex: 1 1 60%;
    `,
};

userInformationStyles.textValueWrapper = {
    css: css`
        display: flex;

        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
    `,
};

userInformationStyles.text = {
    size: fontConfig.fontSize.singleLineRegular,
    lineHeight: fontConfig.lineHeight.singleLineRegular,
    weight: fontConfig.weight.bold,
    css: css`
        flex: 1 1 40%;
        ${xScreen("lte", "md")} {
            flex-basis: auto;
        }
    `,
};
userInformationStyles.value = {
    size: fontConfig.fontSize.singleLineRegular,
    lineHeight: fontConfig.lineHeight.regular,
    css: css`
        flex: 1 1 60%;
        word-break: keep-all;
        ${xScreen("lte", "md")} {
            flex-basis: auto;
        }
    `,
};

userInformationStyles.emailWrapper = {
    css: css`
        display: flex;
        flex: 1 1 60%;
        align-items: baseline;
        gap: 5px;
    `,
};

userInformationStyles.changeEmailModal = { sizeVariant: "small" };

userInformationStyles.buttonsWrapper = {
    css: css`
        display: flex;
        justify-content: end;
        margin-top: 5px;
    `,
};

userInformationStyles.cancelButton = {
    variant: "primary",
    css: css`
        margin-right: 5px;
    `,
};

userInformationStyles.saveButton = {
    sizeVariant: "medium",
    variant: "tertiary",
};

userInformationStyles.emailTextField = {
    cssOverrides: {
        formInputWrapper: css`
            width: 100%;
        `,
    },
};
